import $ from 'jquery';

if (document.querySelectorAll('.js-spa-availability-checker').length) {
    init();
}

function init() {
    spaBookingClickInit();
    initGuestDropdown();
    closeOnClickOfInputField();
};

function spaBookingClickInit() {
    $("#js-spa-booking-submit").click(function () {
        buildSpaBookingUrl(event)
    });
}

function initGuestDropdown() {

    const moreOption = document.querySelector('.js-spa-availability-checker option:last-of-type');

    if (moreOption) {
        moreOption.value = 100;
    }

    const spaSelectWidget = ".js-spa-availability-checker-guests"

    $(spaSelectWidget).select2({
        minimumResultsForSearch: -1,
        allowClear: false,
        placeholder: window.guestPlaceholder,
        dropdownParent: '.selectDropdown-container'

    }).on('change', function () {
        const value = $(".js-spa-availability-checker-guests").select2('val');

        var selectDropdown = document.querySelector('.js-spa-availability-checker-guests');
        var lastValue = selectDropdown.options[selectDropdown.options.length - 1].value;

        const isLastValue = value == lastValue ? true : false
        initShowHideMaxGuests(isLastValue, value)
    })


    $(spaSelectWidget).on('select2:open', function (e) {

        const value = $(".js-spa-availability-checker-guests").select2('val');

        if (value == "") {
            setTimeout(function () {
                const spaDropdownContainerOptions = $(".select2-container--open .select2-results__option");
                spaDropdownContainerOptions.removeClass("select2-results__option--highlighted");
            }, 10)

        }
    });
}

function initShowHideMaxGuests(isLast, value) {

    const element = document.querySelector(".js-max-group-message")
    const label = element.getAttribute('data-label')
    const groupBookingMessage = element.getAttribute('data-groupBooking');
    const maxGuests = element.getAttribute("data-max-guests")
    const formattedLabel = label.replace("{0}", maxGuests)
    const button = document.getElementById("js-spa-booking-submit")
    element.innerHTML = formattedLabel
    if (isLast) {
        element.classList.remove("hide");
        button.setAttribute("disabled", true)
    } else {

        if (value > 1) {
            element.innerHTML = groupBookingMessage
            element.classList.remove("hide");
        } else {
            element.classList.add("hide")
        }



        button.removeAttribute("disabled")
    }
}

function buildSpaBookingUrl(event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    const baseUrl = window.baseUrl

    const numberOfGuests = $(".js-spa-availability-checker-guests").select2('val');
    const date = $("#DesiredDate").datepicker('getDate');

    let queryParams = new URLSearchParams(document.location.search);
    if (numberOfGuests > 0) queryParams.append('guestNoChecker', numberOfGuests)
    if (date !== null) queryParams.append('dateChecker', date)
    sessionStorage.clear();
    if (date !== null && numberOfGuests > 0) {
        const test = baseUrl + "#/treatments?" + queryParams
        window.location.href = test
    }
    window.location.href = baseUrl + "#?" + queryParams
}

function calHide() {
    $("#ui-datepicker-div").datepicker("destroy"); $("#ui-datepicker-div").hide()
};

function calShow() {
    $("#ui-datepicker-div").show();
    $("#ui-datepicker-div .ui-state-hover").removeClass("ui-state-hover")
};

function closeOnClickOfInputField() {
    $(".js-spa-checker-date").on('click', function () {

        $('body').toggleClass('opened');

        if ($('body').hasClass('opened')) {
            calShow();
        } else {
            calHide();
        }
    });
};